import get from 'lodash/get';

const sortTasks = (t1, t2) => {
    if (t1.position < t2.position) {
        return -1;
    }
    if (t1.position > t2.position) {
        return 1;
    }
    return 0;
};

export default {
    computed: {
        addedTasks() {
            if (this.proposalTasks.length > 0) {
                return this.proposalTasks.filter((task) => task.required === false).map((task) => task.id);
            }

            return [];
        },
        proposalTasks() {
            const proposalTasks = get(this, 'proposal.tasks', null);
            return proposalTasks !== null ? proposalTasks.sort(sortTasks) : [];
        },
        tagsDescription() {
            const description = get(this, 'campaign.customization.tracking_step_overview', null);

            if (description !== null) {
                return description;
            }

            return '';
        },
        tags() {
            let tags = [];

            const reportingTags = get(this, 'campaign.reporting');
            const extraTags = get(this, 'campaign.public_tags');

            if (reportingTags) {
                tags = [...tags, ...reportingTags.split('\n')];
            }

            if (extraTags) {
                tags = [...tags, ...extraTags.split('\n')];
            }

            return tags.join(', ');
        }
    },
    methods: {
        requiredTasks(withAdded = false) {
            const campaignTasks = get(this, 'campaign.tasks', null);

            if (campaignTasks !== null) {
                let tasks = campaignTasks.filter((task) => task.required === true);

                if (withAdded) {
                    tasks = [
                        ...tasks,
                        ...campaignTasks.filter((t) => t.required === false && this.addedTasks.includes(t.id))
                    ];
                }

                return tasks.sort(sortTasks);
            }

            return [];
        },
        optionalTasks(withoutAdded = false) {
            if (this.proposal) {
                const tasks = get(this, 'campaign.tasks', null);
                if (tasks !== null) {
                    return tasks
                        .filter(
                            (task) =>
                                task.required === false &&
                                (!withoutAdded || (withoutAdded && !this.addedTasks.includes(task.id)))
                        )
                        .sort(sortTasks);
                }
            }

            return [];
        },
        hasNetwork(task) {
            return Object.prototype.hasOwnProperty.call(task, 'network');
        },
        getTaskTitle(task) {
            if (task.type !== null && task.type.trim().length > 0) {
                return task.type;
            }

            if (this.hasNetwork(task)) {
                return task.network.name;
            }

            return 'Task';
        },
        goToDeliveryPage(task) {
            if (!this.hasNetwork(task)) {
                return;
            }

            if (task.network.slug === 'instagram' && task.media_type === 'story') {
                this.$router.push({
                    name: 'v2.campaign.proposal.task.delivery.story',
                    params: { task_id: task.id }
                });
            } else {
                this.$router.push({
                    name: 'v2.campaign.proposal.task.delivery',
                    params: { task_id: task.id }
                });
            }
        }
    }
};
